import React from "react";
import {
  FaCheck,
  FaDollarSign,
  FaFileAlt,
  FaLayerGroup,
} from "react-icons/fa";

const CARD_CONFIG = {
  general: {
    icon: FaFileAlt,
    accent: "#6366F1",
    accentBg: "bg-indigo-50",
    accentText: "text-indigo-600",
    accentRing: "ring-indigo-200",
  },
  commission: {
    icon: FaDollarSign,
    accent: "#10B981",
    accentBg: "bg-emerald-50",
    accentText: "text-emerald-600",
    accentRing: "ring-emerald-200",
  },
  inquiry_batches: {
    icon: FaLayerGroup,
    accent: "#0EA5E9",
    accentBg: "bg-sky-50",
    accentText: "text-sky-600",
    accentRing: "ring-sky-200",
  },
};

export const COMMISSION_REPORT_TABS = [
  { id: "general", label: "General Report" },
  { id: "commission", label: "Commissionable Students" },
  { id: "inquiry_batches", label: "Inquiry Batches" },
];

function CommissionsReportTabs({
  value,
  onChange,
  visible = true,
  showCommissionStudents = true,
}) {
  if (!visible) return null;

  const tabs = COMMISSION_REPORT_TABS.filter(
    (tab) => tab.id !== "commission" || showCommissionStudents,
  );

  if (!tabs.length) return null;

  return (
    <div className="flex flex-wrap justify-center gap-3">
      {tabs.map((tab) => {
        const cfg = CARD_CONFIG[tab.id];
        const Icon = cfg.icon;
        const active = value === tab.id;

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange?.(tab.id)}
            className={`cms-commissions-report-tab group relative flex w-full min-w-0 max-w-none flex-1 items-center gap-3 overflow-hidden rounded-xl border bg-white px-4 py-3 text-left transition-all duration-200 sm:min-w-[200px] sm:max-w-[260px] ${
              active
                ? `border-transparent shadow-md ring-2 ring-inset ${cfg.accentRing}`
                : "border-gray-200 shadow-sm hover:-translate-y-0.5 hover:shadow-md"
            }`}
            style={{ outline: "none" }}
          >
            {active && (
              <span
                className="absolute inset-x-0 top-0 h-[3px] rounded-t-xl"
                style={{ backgroundColor: cfg.accent }}
                aria-hidden
              />
            )}

            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${cfg.accentBg} ${cfg.accentText}`}
            >
              <Icon size={18} />
            </span>

            <div className="min-w-0 flex-1">
              <p
                className={`truncate text-[13px] font-semibold leading-tight ${
                  active ? "text-gray-900" : "text-gray-700"
                }`}
              >
                {tab.label}
              </p>
            </div>

            {active && (
              <span
                className="absolute right-2.5 top-2.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-white"
                style={{ backgroundColor: cfg.accent }}
              >
                <FaCheck size={7} />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default CommissionsReportTabs;
